var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPause7 = function SvgIconPause7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M29.756 33.674h3.908V22.326h-3.908v11.348zm-7.42 0h3.908V22.326h-3.908v11.348zM47.341 0H8.659C3.896 0 0 3.896 0 8.659v38.682C0 52.104 3.896 56 8.659 56h38.682C52.104 56 56 52.104 56 47.341V8.659C56 3.896 52.104 0 47.341 0z"
  })));
};
export default SvgIconPause7;